import { AppMode, AppModeAction } from '../actions/appMode';

const initialState: AppMode = 'standalone';

const appModeReducer = (state: AppMode = initialState, action: AppModeAction): AppMode => {
	switch (action.type) {
		case 'app/set-mode':
			return action.payload;
		default:
			return state;
	}
};

export default appModeReducer;
